import React from 'react'

interface Props {}

const ManageOrders: React.FC<Props> = () => {
  return <div>ManageOrders</div>
}

export default ManageOrders
